import React from "react";
import { Contact } from "../components/section";
import { UserClient } from "../../../services/proxies/account/userClient";

export const DeleteAccount = () => {
    const userClient = new UserClient();

    return (
        <div className="overflow-x-hidden">
            <Contact
                title="Here & Now Account Deletion"
                formMessageLabel="Reason for Deletion"
                successMessage="Your deletion request has been submitted."
                errorMessage="Failed to submit deletion request."
                onSubmitForm={(payload) =>
                    userClient.submitRequestAccountDeletionForm(payload)
                }
            />
        </div>
    );
};